import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-8% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, description, dark = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <p className={`eyebrow ${dark ? "text-gold" : "text-teal"}`}>{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-5 font-display text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl ${
          dark ? "text-sand-50" : "text-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-sm leading-relaxed md:text-lg ${dark ? "text-sand-50/70" : "text-slate-600"}`}>
          {description}
        </p>
      </Reveal>
    )}
  </div>
);
